import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    CarouselIndicatorsDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

const stylesheet = StyleSheet.create({
    dotsRow: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "nowrap",
        minWidth: 0
    },
    dotsColumn: {
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        flexWrap: "nowrap",
        minWidth: 0
    },
    badge: {
        justifyContent: "center",
        alignSelf: "flex-start",
        pointerEvents: "none",
        alignItems: "center"
    },
    thumbs: {
        flexDirection: "row",
        minWidth: 0
    },
    counter: {
        fontVariant: [
            "tabular-nums"
        ],
        flexShrink: 0
    }
});

export const useStyles = ({
    shapeConfigs,
    typography,
    radiuses,
    borders,
    colors,
    spaces
}: Omit<CarouselIndicatorsDynamicStyleType, "orientation">) => {
    return {
        badge: {
            minHeight: typography.labelSmallSize.lineHeight + spaces.spacingXxs * 2,
            backgroundColor: colors.content.container.inverse,
            paddingHorizontal: spaces.spacingSm,
            ...getCornerStyle({
                radius: radiuses.chip,
                shapeConfigs
            })
        } as Mutable<ViewStyle>,
        thumbs: {
            padding: borders.focus * 2,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };
};
export default stylesheet;
